<div class="sticky bottom-0 z-10 opacity-95">
  <div class="float-right mr-2">&#169;{{ year }} by Ymif - v{{ version }}</div>
</div>
